import styled from '@emotion/styled';

import { BREAKPOINTS, COLORS, FONT_SIZE, SPACE } from '@/constants';
import Icon from '@/components/icons';

const BOX_SHADOW_BOTTOM = `0 10px 17px -10px ${COLORS.GREY_FOUR}`;

const Filter = styled.li`
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: calc(${SPACE.X1} + ${SPACE.X0}) 0;
  cursor: pointer;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;

  @media (min-width: ${BREAKPOINTS.MD}px) {
    font-size: ${FONT_SIZE.MEDIUM};
    border-bottom: 4px solid transparent;

    :focus-visible {
      color: ${COLORS.BRAND_BLUE_EIGHT};
    }

    :focus:not(:focus-visible) {
      outline: none;
    }

    ${
      /* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'isOpen' does not exist on type '{ theme?: Theme | undefined; as?: ElementType<any, keyof IntrinsicElements> | undefined; } & ClassAttributes<HTMLLIElement> & LiHTMLAttributes<...> & { ...; }'. */
      ({ isOpen }) =>
        isOpen &&
        `
    color: ${COLORS.BRAND_BLUE_SIX};
    border-color: ${COLORS.BRAND_BLUE_SIX};
    `
    }
  }

  margin-right: ${SPACE.X0};
`;

const Filters = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
`;

const StyledIcon = styled(Icon)`
  margin-left: ${SPACE.X0};
  height: 18px;
  width: 18px;
  min-height: 18px;
  min-width: 18px;

  ${
    /* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'isOpen' does not exist on type 'IconProps & { theme?: Theme | undefined; } & { theme: Theme; }'. */
    ({ isOpen }) =>
      isOpen &&
      `
    transform: rotate(180deg);
    @media (min-width: ${BREAKPOINTS.MD}px) {
      fill: ${COLORS.BRAND_BLUE_SIX} !important;
    }
    `
  };
`;

const Divider = styled.div`
  background: ${COLORS.GREY_FOUR};
  width: 100%;
  height: 1px;
`;

const SelectionPanel = styled.div`
  z-index: 0;
  @media (min-width: ${BREAKPOINTS.MD}px) {
    background: ${COLORS.WHITE};
    box-shadow: ${BOX_SHADOW_BOTTOM};
  }

  padding-bottom: calc(${SPACE.X1} + ${SPACE.X0});
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
`;

const FilterHeader = styled.div`
  box-shadow: ${BOX_SHADOW_BOTTOM};
  background: ${COLORS.WHITE};
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const FilterButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export { Filter, StyledIcon, Divider, SelectionPanel, Filters, FilterHeader, Column, FilterButtonWrapper };
